module.exports = __webpack_public_path__ + "static/CircularStd-Medium-029c2e0e19032f6cdbef9042552e79fa.woff2";